// @flow
import { connect } from 'react-redux';

import { fetchCompetitionsInternationales } from 'actions/competitionsInternationalesActions';
import CompetitionsInternationales from 'components/competitionsInternationales/competitionsInternationales';
import type { StateType, DispatchType } from 'types/Actions';
import type { StateProps, DispatchProps } from 'components/competitionsInternationales/competitionsInternationales';

export default connect(
  (state: StateType): StateProps => ({
    data: state.competitionsInternationalesState.data,
    status: state.competitionsInternationalesState.status
  }),
  (dispatch: DispatchType): DispatchProps => ({
    fetchCompetitionInternationale: (slug: string) => dispatch(fetchCompetitionsInternationales(slug))
  })
)(CompetitionsInternationales);
